import React, { useEffect, useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Switch } from "../ui/switch";
import { adminDiscounts, adminCreateDiscount, adminToggleDiscount, adminDeleteDiscount } from "../../services/api";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";

export const AdminDiscounts = () => {
  const [codes, setCodes] = useState([]);
  const [form, setForm] = useState({ code: "", type: "percent", value: "", min_total: "" });

  const load = () => adminDiscounts().then(setCodes).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await adminCreateDiscount({
        code: form.code, type: form.type, value: parseFloat(form.value),
        min_total: form.min_total ? parseFloat(form.min_total) : null,
      });
      toast.success(`Gutschein ${form.code.toUpperCase()} angelegt`);
      setForm({ code: "", type: "percent", value: "", min_total: "" });
      load();
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Fehler beim Anlegen");
    }
  };

  const toggle = async (code) => { await adminToggleDiscount(code); load(); };
  const remove = async (code) => {
    if (!window.confirm(`Gutschein ${code} wirklich löschen?`)) return;
    await adminDeleteDiscount(code);
    toast.success(`${code} gelöscht`);
    load();
  };

  return (
    <div data-testid="admin-discounts">
      <form onSubmit={create} className="bg-white rounded-2xl border border-border p-5 mb-6 grid sm:grid-cols-[1fr_130px_110px_130px_auto] gap-3 items-center">
        <Input data-testid="discount-new-code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} placeholder="CODE (z. B. SOMMER25)" required minLength={3} />
        <select data-testid="discount-new-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}
          className="h-10 rounded-md border border-input bg-white px-3 text-sm">
          <option value="percent">% Rabatt</option>
          <option value="fixed">CHF Betrag</option>
        </select>
        <Input data-testid="discount-new-value" type="number" step="0.5" min="0.5" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} placeholder={form.type === "percent" ? "%" : "CHF"} required />
        <Input data-testid="discount-new-min" type="number" step="1" min="0" value={form.min_total} onChange={(e) => setForm({ ...form, min_total: e.target.value })} placeholder="Mindestbestellwert" />
        <Button data-testid="discount-create-button" type="submit" className="bg-wine hover:bg-wine-dark text-white gap-1"><Plus className="w-4 h-4" /> Anlegen</Button>
      </form>

      <div className="space-y-2">
        {codes.map((c) => (
          <div key={c.code} className="bg-white rounded-xl border border-border px-5 py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`discount-row-${c.code}`}>
            <div className="flex items-center gap-3">
              <span className="font-mono font-semibold text-wine">{c.code}</span>
              <Badge variant="outline" className="border-wine/20 text-ink/60">
                {c.type === "percent" ? `−${c.value}%` : `−CHF ${c.value.toFixed(2)}`}{c.min_total ? ` · ab CHF ${c.min_total}` : ""}
              </Badge>
              <span className="text-xs text-ink/40">{c.usage_count || 0}× eingelöst</span>
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-xs ${c.active ? "text-green-700" : "text-ink/40"}`}>{c.active ? "Aktiv" : "Inaktiv"}</span>
              <Switch data-testid={`discount-toggle-${c.code}`} checked={c.active} onCheckedChange={() => toggle(c.code)} />
              <button data-testid={`discount-delete-${c.code}`} onClick={() => remove(c.code)} className="text-ink/30 hover:text-red-500 transition-colors"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
